import { render, staticRenderFns } from "./ProcessingRevisionHistory.vue?vue&type=template&id=d1e724ec&scoped=true&"
import script from "./ProcessingRevisionHistory.vue?vue&type=script&lang=ts&"
export * from "./ProcessingRevisionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessingRevisionHistory.vue?vue&type=style&index=0&id=d1e724ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e724ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
